// extracted by mini-css-extract-plugin
export default {"hideTooltip":"g9-z","fadeIn":"h9-z","delay":"i9-z","recommendedSizeTooltip":"j9-z"};